import SectionHeading from "@/components/base/SectionHeading";
import { communityFeatures } from "@/mocks/homeContent";

export default function Community() {
  return (
    <section id="community" className="scroll-mt-24 w-full bg-background-50 py-16 md:py-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="社区亮点"
          title="装好之后，你能在社区里做什么"
          desc="榴莲视频不只是一个播放器，而是一个可以浏览、互动与创作的内容社区。安装完成并登录后，这些功能会陆续开放。"
        />

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {communityFeatures.map((item) => (
              <div
                key={item.title}
                className="bg-background-100 border border-background-200 rounded-lg p-5"
              >
                <span className="w-10 h-10 rounded-md bg-accent-500 text-background-50 flex items-center justify-center text-xl">
                  <i className={item.icon} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 text-sm md:text-base font-semibold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm leading-relaxed text-foreground-600">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <div className="relative rounded-lg overflow-hidden border border-background-200 min-h-[220px]">
              <img
                src="https://readdy.ai/api/search-image?query=Young%20people%20watching%20short%20videos%20on%20phones%20in%20a%20warm%20cozy%20cafe%2C%20amber%20and%20green%20color%20tone%2C%20lifestyle%20editorial%20photography%2C%20soft%20natural%20lighting%2C%20high%20detail&width=800&height=1000&seq=durian-community-01&orientation=portrait"
                alt="用户在温馨环境中观看视频的场景"
                className="absolute inset-0 w-full h-full object-cover"
              />
            </div>
            <div className="relative rounded-lg overflow-hidden border border-background-200 min-h-[220px]">
              <img
                src="https://readdy.ai/api/search-image?query=Content%20creator%20editing%20video%20on%20a%20smartphone%20with%20ring%20light%2C%20warm%20amber%20and%20green%20accents%2C%20clean%20minimal%20studio%20setup%2C%20editorial%20photography%2C%20high%20detail&width=800&height=1000&seq=durian-community-02&orientation=portrait"
                alt="内容创作者用手机剪辑视频的场景"
                className="absolute inset-0 w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}